import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da entidade LinhaProducao */
export class LinhaProducaoFilter implements Filter {
    situacao: number;

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        return params;
    }

    clear() {
        this.situacao = null;
    }
}

